module.exports = __webpack_public_path__ + "static/orkut_1-deb64f407ebecd833475bb458817029f.png";